/**
 * Shared narrowing for untrusted provider and edge-function payloads.
 *
 * Both credential parsers and the event decoder need the same two questions
 * answered — "is this a plain JSON object?" and "is this field a usable
 * string?" — and each had grown its own copy of the check.
 */

/** An untrusted, already-JSON-parsed frame from a provider socket or edge call. */
export type ProviderEvent = Record<string, unknown>;

function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (typeof value !== "object") {
    return false;
  }
  if (value === null) {
    return false;
  }
  return !Array.isArray(value);
}

/** Narrows to a plain JSON object, rejecting `null` and arrays. */
export function asRecord(value: unknown): Record<string, unknown> | null {
  return isPlainObject(value) ? value : null;
}

/** Reads a trimmed string field, yielding "" when absent or the wrong type. */
export function readString(source: Record<string, unknown>, key: string): string {
  const value = source[key];
  return typeof value === "string" ? value.trim() : "";
}
